export class Auth {
    _id: string;
    id: string;
    loginFlag: boolean;
    name: string;
    profileImg: {
        imgUrl: string,
        name: string
    };
    role: {
        name: string,
        permission: {
            db: any,
            page: any
        }
    };
    token: string;
    constructor() {
        this.loginFlag = false;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/auth.ts